import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/Headers/Header";
import {
  Container,
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Table,
  Input,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { getAllManagers } from "store/actions/managerAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

function Manager() {
  let dispatch = useDispatch();
  const [id, setId] = useState("");
  const { allManagers } = useSelector((state) => state.earnings);
  const { managers, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.manager
  );

  const columns = [
    "Name",
    "Email",
    "Manager Id",
    "State",
    "Total Earning",
    "Created At",
  ];
  const keyMap = {
    Name: "name",
    Email: "email",
    State: "state",
    "Manager Id": "managerID",
    "Total Earning": "earnings",
    "Created At": "created_at",
  };
  const infoPoints = [
    "In the Manager module, the admin can view all managers registered on the FHP platform, along with their earnings generated through participation in various cards and chats.",
  ];
  const subPoints = [];
  const infoTitle = "Manager Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const formattedData = managers.map((item) => ({
    ...item,
    id: item.id || item._id || item.managerID,
    created_at: item.created_at
      ? moment.unix(item.created_at.seconds).format("DD-MM-YYYY")
      : "N/A",
  }));
  const [dataloader, setDataLoader] = useState(true);
  const [btnLoader, setBtnLoader] = useState({
    apply: false,
    clear: false,
    loadmore: false,
  });
  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getAllManagers("", "", () => {
        setDataLoader(false);
      })
    );
  }, []);

  const applyFilter = () => {
    setBtnLoader((prev) => ({
      ...prev,
      apply: true,
    }));
    dispatch(
      getAllManagers(id, "", () => {
        setBtnLoader((prev) => ({
          ...prev,
          apply: false,
        }));
      })
    );
  };
  const ClearFilter = () => {
    setBtnLoader((prev) => ({
      ...prev,
      clear: true,
    }));
    dispatch(
      getAllManagers("", "", () => {
        setBtnLoader((prev) => ({
          ...prev,
          clear: false,
        }));
        setId("");
      })
    );
  };

  const handleLoadMore = () => {
    setBtnLoader((prev) => ({
      ...prev,
      loadmore: true,
    }));
    dispatch(
      getAllManagers(id, lastDocument, () => {
        setBtnLoader((prev) => ({
          ...prev,
          loadmore: false,
        }));
      })
    );
  };

  const renderActions = (row) => (
    <>
      <Link to={`manager-earning/${row.id}`}>
        <Button size="sm" color="primary">
          Manager Earning
        </Button>
      </Link>
    </>
  );
  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Row className="mt-3">
          <Col>
            <Card className="filter-card">
              <CardBody className="custom-card-body">
                <Row className="mt-1">
                  <Col xs={12} sm={6} md={4}>
                    <Input
                      value={id}
                      name="ID"
                      onChange={(e) => setId(e.target.value)}
                      type="text"
                      placeholder="Search By ID"
                      className="mt-2 mt-sm-0 custom-filter-input"
                    />
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={8}
                    className="d-flex justify-content-center justify-content-sm-end align-items-center mt-2 mt-sm-0"
                  >
                    <Button
                      size="sm"
                      color="danger"
                      onClick={ClearFilter}
                      disabled={btnLoader.clear}
                      className="me-sm-2"
                    >
                      {btnLoader.clear ? <Spinner size="sm" /> : "Clear"}
                    </Button>
                    <Button
                      size="sm"
                      color="primary"
                      onClick={applyFilter}
                      disabled={btnLoader.apply}
                    >
                      {btnLoader.apply ? <Spinner size="sm" /> : "Apply"}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {dataloader ? (
          <div className="text-center mt-5">
            <Spinner color="primary" className="mx-auto" />
          </div>
        ) : (
          <>
            {managers?.length == 0 ? (
              <Card className="filter-card mt-4">
                <CardBody className="bg-danger text-center rounded">
                  <h2 className="text-white">
                    <i className="fa fa-exclamation-triangle mr-3"></i> No
                    Player Found
                  </h2>
                </CardBody>
              </Card>
            ) : (
              <Card className="p-2 mt-4">
                <TableComponent
                  columns={columns}
                  data={formattedData}
                  keyMap={keyMap}
                  renderActions={renderActions}
                />
                {managers.length > 4 && hasMoreDocument && (
                  <div className="text-center py-4">
                    <Button
                      color="primary"
                      onClick={handleLoadMore}
                      disabled={btnLoader.loadmore}
                    >
                      {btnLoader.loadmore ? <Spinner size="sm" /> : "Load more"}
                    </Button>
                  </div>
                )}
              </Card>
            )}
          </>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
}

export default Manager;
